import { render, staticRenderFns } from "./ShowcaseTable.vue?vue&type=template&id=1b355060&"
import script from "./ShowcaseTable.vue?vue&type=script&lang=js&"
export * from "./ShowcaseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports